import React, { useState } from 'react';
import styled from 'styled-components';

import { ApiOrderRaw } from 'api/types';
import MaterialSymbol from 'components/basic/icons/MaterialSymbol';
import { cancelOrderWithSignModal } from 'components/orders/orderCancelUtils';
import { useSelector } from 'reduxState/storeCore';

import { cancelConditionalTPSLOrderWithSignModal } from './tpSlUtils';

const CloseIconWrap = styled.div<{ $disabled: boolean }>`
  color: var(--gray2);
  padding-top: 8px;
  ${({ $disabled }) =>
    $disabled
      ? `color: var(--gray1);
      cursor: not-allowed;`
      : `&:hover {
      cursor: pointer;
      color: var(--gray3);
    }`}
`;

export default function TPSLRemoveButton({
  valueEmpty,
  currentOrder,
  onRemove,
}: {
  valueEmpty: boolean;
  currentOrder: ApiOrderRaw | undefined;
  onRemove: () => void;
}) {
  const wallet = useSelector(state => state.wallet);
  const delegatedKeyAuthorization = useSelector(
    state => state.delegatedKey.authorization
  );
  const [canceling, setCanceling] = useState(false);
  // const { cancelingOrderId, handleCancelOrder, renderCancelation } = useCancelOrder();
  const disabled = canceling || (!currentOrder && valueEmpty);

  const handleClick = async () => {
    if (currentOrder) {
      setCanceling(true);
      if (!currentOrder.conditionalOrderId) {
        await cancelOrderWithSignModal(
          currentOrder.orderId,
          wallet,
          delegatedKeyAuthorization
        );
        return;
      }
      // Conditional TPSL Order
      const type =
        currentOrder.type === 'takeProfitMarket'
          ? 'takeProfit'
          : currentOrder.type === 'stopLossMarket'
          ? 'stopLoss'
          : undefined;
      if (!type) {
        throw new Error('Unknown Conditional TPSL type');
      }
      await cancelConditionalTPSLOrderWithSignModal(
        currentOrder.conditionalOrderId,
        type,
        wallet,
        delegatedKeyAuthorization
      );
    }
    onRemove();
    setCanceling(false);
  };

  return (
    <CloseIconWrap
      onClick={disabled ? undefined : handleClick}
      $disabled={disabled}
    >
      <MaterialSymbol icon="close" />
    </CloseIconWrap>
  );
}
